import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';
import { ActivatedRoute } from '@angular/router';
import { CheckBoxMultiNivelEstructura } from '../checkbox-multinivel/checkbox-multinivel.component';
import { PopoverController } from '@ionic/angular';
import { PopoverMostrarLinkComponent } from '../popover-mostrar-link/popover-mostrar-link.component';
import { IonModal } from '@ionic/angular';


export interface Familias {
  CodigoFamilia: string;
  ApellidoFamilia: string;
  Id: number;
}


@Component({
  selector: 'app-tabla-familia-user',
  templateUrl: './tabla-familia-user.component.html',
  styleUrls: ['./tabla-familia-user.component.scss'],
})
export class TablaFamiliaUserComponent implements OnInit {
  @ViewChild(IonModal) modal: IonModal;
  displayedColumns: string[] = ['select', 'CodigoFamilia', 'ApellidoFamilia', 'Acciones'];
  dataSource: MatTableDataSource<Familias>;
  selection = new SelectionModel<Familias>(true, []);

  filtro = "";
  UserID = ""
  User: any = {};

  Hijos = []
  FamiliaSelect = ""
  openModal = false;

  Cursos = []
  CursosMultinivel: Array<CheckBoxMultiNivelEstructura> = [];
  Destinos = []

  TiposUsuarios = []

  Cargado = false;

  HijosAll = []
  @Output() hijosEmit = new EventEmitter()


  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService,
    private activated: ActivatedRoute, private popoverController: PopoverController) {
    this.dataSource = new MatTableDataSource([])
  }

  ngOnInit() {
    this.UserID = this.activated.snapshot.paramMap.get("UserID")
    this.getCursosDestinos()
    this.getTiposUsuarios()
    this.getUsuario()
    setTimeout(() => {
      this.getFamiliasUsuario(this.UserID)
    }, 100);
    //dd

   
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  getHijosFamilia(cod: string) {
    this.utilidades.Loading("")
    this.conexion.getHijosFamilia(cod).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.Hijos = resp.Datos;
        this.openModal = true
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)
      this.utilidades.CerrarLoading()
      this.utilidades.ValidarUser(err)
    })
  }

  cancel() {
    this.modal.dismiss(null, 'cancel');
  }

  GenerarEnlaceCambioContrasena() {
    this.utilidades.Loading("Generando")
    this.conexion.RecuperarPassword(this.User.Email).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Toast(resp.Mensaje)
      if (resp.Respuesta == "Exito") {
        this.MostrarPopoverGeneradoLink(resp.Datos)
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
    })
  }

  async MostrarPopoverGeneradoLink(link) {
    const popover = await this.popoverController.create({
      component: PopoverMostrarLinkComponent,
      componentProps: {
        Link: link
      }
    });

    await popover.present();
  }

  ReenviarCorreoActivacion() {
    this.utilidades.Loading("Reenviando correo")
    let datos = { Usuarios: [this.User] }
    this.conexion.ReenviarCorreoActivacion(datos).subscribe((resp) => {
      this.Cargado = false;
      this.getUsuario()
      this.utilidades.CerrarLoading()
      this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  getCursosDestinos() {
    // this.utilidades.Loading("Cargando las categorias")
    this.conexion.getCursosDestinos().subscribe((resp) => {
      // this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.utilidades.Depuracion(resp, "console", "")
        this.Cursos = resp.Datos;
        this.CursosMultinivel = []
        for (let i in this.Cursos) {
          this.CursosMultinivel.push({
            name: this.Cursos[i].Descripcion, completed: false,
            subtasks: []
          })
          for (let j of this.Cursos[i].Secciones) {
            this.CursosMultinivel[i].subtasks.push({ name: j.Curso + " " + j.Seccion, completed: false, value: j.Id })
          }
        }

        this.utilidades.Depuracion(this.CursosMultinivel, "console", "")
      }
    }, (err) => {
      // this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  EstablecerDestinos() {
    this.utilidades.Loading("Estableciendo...")
    this.conexion.AsociarUsuariosCursos(this.UserID, this.Destinos, 1).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }


  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.data.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    this.isAllSelected() ?
      this.selection.clear() :
      this.dataSource.data.forEach(row => this.selection.select(row));
  }


  getUsuario() {
    this.conexion.getUsuario(this.UserID).subscribe((resp) => {
      if (resp.Respuesta == "Exito") {
        this.User = resp.Datos
        localStorage.setItem(btoa("Destinos"), btoa(JSON.stringify(resp.Datos.Destinos)))
        this.utilidades.Depuracion(this.User, "console", "")
        this.Destinos = this.User.Destinos
        this.HijosAll = resp.Datos.Hijos
        this.hijosEmit.emit(this.HijosAll)
        setTimeout(() => {
          this.Cargado = true
        }, 500);
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  getFamiliasUsuario(cod: string) {
    this.utilidades.Loading("Cargando usuarios")
    this.conexion.getFamiliasUsuario(cod).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      if (resp.Respuesta == "Exito") {
        this.dataSource = new MatTableDataSource(resp.Datos);
        this.ngAfterViewInit()
      }
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  CambiarEstado(Estado) {
    this.utilidades.Loading("Cambiando estado del usuario")
    let datos = { Usuarios: [{ Id: this.UserID }], Estado }
    this.conexion.CambiarEstadoUsuario(datos).subscribe((resp) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Toast(resp.Mensaje)
      this.getUsuario()
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }


  DesvincularFamilia() {

  }


  getRol(IdTipo) {
    for (let i of this.TiposUsuarios) {
      if (i.Id == IdTipo) {
        return i.Tipo
      }
    }
    return ""
  }

  DesvincularFamiliasUsuario() {
    if (!this.selection.selected) {
      this.utilidades.Alerta("No hay usuarios seleccionados")
      return 0;
    }

    let datos = { Familias: this.selection.selected, UserID: this.UserID }

    this.conexion.DesvincularFamiliasUsuario(datos).subscribe((resp) => {
      this.utilidades.Toast(resp.Mensaje)
      this.getFamiliasUsuario(this.UserID)
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })

  }

  CambiarRolUsuario() {
    if(this.Cargado==false){return 0}
    this.utilidades.Loading("Cambiando rol del usuario")
    this.conexion.CambiarRolUsuario(this.User.Id, this.User.Roles).subscribe((resp) => {
      this.utilidades.CerrarLoading()
 
     this.utilidades.Toast(resp.Mensaje)
    }, (err) => {
      this.utilidades.CerrarLoading()
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

  getTiposUsuarios() {
    this.conexion.getTiposUsuarios().subscribe((resp) => {
      if (resp.Respuesta == "Exito") {
        this.TiposUsuarios = (resp.Datos);
  
      }
    }, (err) => {
      this.utilidades.Depuracion(err.error.Mensaje, "", err.error.Codigo)

      this.utilidades.ValidarUser(err)
    })
  }

}
